import React from "react"
import types from "prop-types"
import { useDispatch } from "react-redux"
import { closeConversation } from "reduxSlices/formSubmissionConversationsSlice"
import { PrimaryButton } from "shared/buttons"

const ConversationActionClose = ({ conversationId }) => {
  const dispatch = useDispatch()

  const close = () => dispatch(closeConversation({ conversationId }))

  return (
    <PrimaryButton onClick={close} text="Close Conversation" />
  )
}

ConversationActionClose.propTypes = {
  conversationId: types.number.isRequired,
}

export default ConversationActionClose
